import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AcademyPage from './pages/AcademyPage';
import ProgramsPage from './pages/ProgramsPage';
import NooraniQaidaPage from './pages/NooraniQaidaPage';
import QuranReadingPage from './pages/QuranReadingPage';
import TajweedPage from './pages/TajweedPage';
import HifzPage from './pages/HifzPage';
import TafseerPage from './pages/TafseerPage';
import IslamicStudiesPage from './pages/IslamicStudiesPage';
import PricingPage from './pages/PricingPage';
import BlogPage from './pages/BlogPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="academy" element={<AcademyPage />} />
          <Route path="programs" element={<ProgramsPage />} />
          <Route path="programs/noorani-qaida" element={<NooraniQaidaPage />} />
          <Route path="programs/quran-reading" element={<QuranReadingPage />} />
          <Route path="programs/tajweed" element={<TajweedPage />} />
          <Route path="programs/hifz" element={<HifzPage />} />
          <Route path="programs/tafseer" element={<TafseerPage />} />
          <Route path="programs/islamic-studies" element={<IslamicStudiesPage />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
